export default {
   largeTablet: 1100,
   tablet: 800,
   largeMobile: 620,
   horMobile: 480,
   verMobile: 320,
};